// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1634":"b7915baa","3131":"f652aa73","3892":"1f502c87","5632":"5c153c23","7349":"60e88bc3","9879":"42f0b9ee"}[chunkId] + ".chunk.css";
};